
import React, { useContext } from 'react';
import { Toolbar } from 'primereact/toolbar';
import { Button } from 'primereact/button';
import { ToolsContext, ToolsDispatchContext, Toolset, mainToolset, Tool } from '../ToolsContext';
import SnapshotSelect from '../features/SnapshotSelect';
import { RoutePickDropdown } from '../components/RoutePickDropdown';

export function MainToolbar() {
    const tool = useContext(ToolsContext);
    const toolDispatch = useContext(ToolsDispatchContext);
    const startContent = [];
    for (const [key, val] of Object.entries(mainToolset.tools)) {
        startContent.push(<ToolButton key={key} icon={val.icon} tool={val} selected={(tool.name === key)} />);
    }

    let centerContent = <></>
    
    if(tool.name === 'timetablesTool') {
        centerContent = <RoutePickDropdown 
                    onDone={(value) => {
                        toolDispatch({
                            type: 'changed',
                            newTool: {
                                ...tool,
                                selection: value
                            }
                        });
                    }}        
            />
    }
    

    /*
    const centerContent = (
        <IconField iconPosition="left">
            <InputIcon className="pi pi-search" />
            <InputText placeholder="Search" />
        </IconField>
    );
     */

    const endContent = (
        <React.Fragment>
            <SnapshotSelect></SnapshotSelect>
        </React.Fragment>
    );

    return (
        <div className="mb-2">
            <Toolbar start={startContent} center={centerContent} end={endContent} className='p-3' />
        </div>
    );
}

function ToolButton({tool, icon, selected}) {
    const dispatch = useContext(ToolsDispatchContext);
    let className = "mr-2";
    let style = {
        /* fontSize: '1.2rem' */
    };
    if(selected) {
        style = {
            ...style, 
            backgroundColor: 'var(--yellow-500)', 
            color: 'black'};
    }
    return (
        <Button text 
            icon={icon} 
            className={className} 
            style={style} 
            tooltip={tool.description}
            tooltipOptions={{ position: 'bottom' }}
            onClick={() => {
                dispatch({
                    type: 'changed',
                    newTool: {...tool}
                });
            }} />
    )
}